<template>
  <v-menu
    v-model="menuActive"
    :close-on-content-click="false"
    :location="location"
    transition="scale-transition"
    min-width="auto"
  >
    <template #activator="{ props: activatorProps }">
      <v-text-field
        :model-value="modelValue"
        readonly
        v-bind="{ ...$attrs, ...activatorProps }"
        @click:clear.stop="onClear"
      />
    </template>
    <v-date-picker
      :model-value="toPickerDate(modelValue)"
      :min="toPickerDate(min)"
      :max="toPickerDate(max)"
      v-bind="pickerProps"
      @update:model-value="onSelect"
    />
  </v-menu>
</template>

<script>
import { fromPickerDate, toPickerDate } from '@/utils/datePickerUtils'

export default {
  name: 'SDateField',
  inheritAttrs: false,
  props: {
    // "YYYY-MM-DD" or null. Attrs other than the ones below reach the text field.
    modelValue: {
      type: String,
      default: null,
    },
    min: {
      type: [String, Date],
      default: null,
    },
    max: {
      type: [String, Date],
      default: null,
    },
    // Extra v-date-picker attrs, e.g. { 'first-day-of-week': 1 }
    pickerProps: {
      type: Object,
      default: () => ({}),
    },
    location: {
      type: String,
      default: undefined,
    },
  },
  // `change` fires once per committed value: a picked date or a clear
  emits: ['update:modelValue', 'change'],
  data () {
    return {
      menuActive: false,
    }
  },
  methods: {
    toPickerDate,
    commit (value) {
      this.$emit('update:modelValue', value)
      this.$emit('change', value)
    },
    onSelect (date) {
      const value = fromPickerDate(date)
      // VDatePicker also emits on month/year navigation clicks that select nothing
      if (!value) {
        return
      }
      this.menuActive = false
      this.commit(value)
    },
    onClear () {
      this.menuActive = false
      this.commit(null)
    },
  },
}
</script>
